// Delegated click handler for in-page anchors inside v-html content, where
// Vue handlers can't be attached to the links themselves. Upgrades the
// browser's hard jump to a smooth scroll; scroll-margin-top on the target is
// still honoured. Used by the adviser pages ("View Terms and condition",
// FAQ "Click here to register").
export function smoothScrollToAnchor(event) {
  const link = event.target.closest('a[href^="#"]');
  if (!link) return;
  const target = document.querySelector(link.getAttribute('href'));
  if (!target) return;
  event.preventDefault();
  target.scrollIntoView({ behavior: 'smooth' });
}
